module.exports = __webpack_public_path__ + "fonts/Poppins-BlackItalic.3fb21c80.ttf";